import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { PageAlert } from "capitalrx-components";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { getBatchManualClaimListActions } from "@/App/actions";
import { BatchManualClaimTypes, GeneralTypes } from "@/types";
import { getManualClaimListResults } from "@/App/actions/appActions/transmissions/batchManual/list";

function formatData(
  data: Array<{
    batch_manual_file: BatchManualClaimTypes.BatchManualClaim;
  }>,
): Array<BatchManualClaimTypes.BatchManualClaim> {
  return data.map((val) => {
    return {
      created_at: val.batch_manual_file.created_at,
      id: val.batch_manual_file.id,
      original_name: val.batch_manual_file.original_name,
      status: val.batch_manual_file.status,
      type: val.batch_manual_file.type,
    };
  });
}

function* getBatchManualClaimList(payload: { queryOptions: GeneralTypes.QueryOptions }): Generator {
  return yield apiService({
    url: "/transmission/batch_manual/list",
    method: "POST",
    data: payload.queryOptions,
  });
}

export function* getBatchManualClaimListWorker(action: ReturnType<typeof getBatchManualClaimListActions.getManualClaimList>): SagaIterator {
  const { payload } = action;
  const { showPageAlert } = PageAlert;

  try {
    const { results, result_count } = yield call(getBatchManualClaimList, payload);
    const formattedData = formatData(results);

    yield put(
      getManualClaimListResults({
        results: formattedData,
        result_count: result_count,
      }),
    );
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message }));
  }
}

export default function* getBatchManualClaimWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.GET_BATCH_TRANSMISSION_MANUAL_CLAIM_LIST, getBatchManualClaimListWorker);
}
